//Import Css
import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'flag-icon-css/css/flag-icon.min.css'
import 'flatpickr/dist/flatpickr.css'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import 'element-ui/lib/theme-chalk/index.css';

//import css
import '@/assets/default/app.min.css'
// import '@/assets/default/style-responsive.min.css'
// import '@/assets/default/theme/red.min.css'
// import '@/assets/default/style.css'

// import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

// import mixins
import mixinMethods from '@/assets/mixin/methods.js'

import Vue from 'vue'
import App from './App.vue'

// import fontawesome
import '@/assets/fontawesome/all.min.css';

//for older browser compatibility
import 'es6-promise'

import VueX from 'vuex'

//routes
import router from './Options/router.js'

//store
import storeOptions from './store/store.js'

//axios
import Axios from 'axios'
Axios.defaults.baseURL = env.urlStart;
Vue.prototype.$http = Axios; // to run axios, just use this.$http

//vue bootstrap
import VueBootstrap from 'bootstrap-vue'

//vuetify
// const Vuetify = () => import('vuetify')

//VueInsProgress
import VueInsProgressBar from 'vue-ins-progress-bar'

//import SweetAlert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

//import vue meta
import VueMeta from 'vue-meta';

//import env
import env from './env.js';

//add panel for global use
import VuePanel from './plugins/panel/'

import vueUniversalTable from '@/components/table/vue_universal_table.vue'
import MultiSelect from 'vue-multiselect';
import flatPickr from 'vue-flatpickr-component';
import VueHtmlToPaper from 'vue-html-to-paper';
import VueNativeNotification from 'vue-native-notification'

import VueSignaturePad from 'vue-signature-pad';
 
Vue.use(VueSignaturePad);
 


const vueHtmlToPaperOptions = {
  name: '_blank',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes'
  ],
  styles: [
    'https://stackpath.bootstrapcdn.com/bootstrap/4.5.2/css/bootstrap.min.css',
    'https://unpkg.com/kidlat-css/css/kidlat.css',
    '/avoid.css'
  ]
}


//Vue use 
import VueSocketIOExt from 'vue-socket.io-extended';
import io from 'socket.io-client';
 
const socket = io(env.urlStart);
 
Vue.use(VueSocketIOExt, socket);
Vue.use(VueX)
Vue.use(VueBootstrap)
Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px'
})
Vue.use(VueNativeNotification, {
  // Automatic permission request before
  // showing notification (default: true)
  requestOnNotify: true
})
Vue.filter('terbilang', function (value) {
	function terbilang(a){var c=" Satu Dua Tiga Empat Lima Enam Tujuh Delapan Sembilan Sepuluh Sebelas".split(" ");if(12>a)var b=c[a];else 20>a?b=c[a-10]+" Belas":100>a?(b=parseInt(String(a/10).substr(0,1)),b=c[b]+" Puluh "+c[a%10]):200>a?b="Seratus "+terbilang(a-100):1E3>a?(b=parseInt(String(a/100).substr(0,1)),b=c[b]+" Ratus "+terbilang(a%100)):2E3>a?b="Seribu "+terbilang(a-1E3):1E4>a?(b=parseInt(String(a/1E3).substr(0,1)),b=c[b]+" Ribu "+terbilang(a%1E3)):1E5>a?(b=parseInt(String(a/100).substr(0,2)),
	a%=1E3,b=terbilang(b)+" Ribu "+terbilang(a)):1E6>a?(b=parseInt(String(a/1E3).substr(0,3)),a%=1E3,b=terbilang(b)+" Ribu "+terbilang(a)):1E8>a?(b=parseInt(String(a/1E6).substr(0,4)),a%=1E6,b=terbilang(b)+" Juta "+terbilang(a)):1E9>a?(b=parseInt(String(a/1E6).substr(0,4)),a%=1E6,b=terbilang(b)+" Juta "+terbilang(a)):1E10>a?(b=parseInt(String(a/1E9).substr(0,1)),a%=1E9,b=terbilang(b)+" Milyar "+terbilang(a)):1E11>a?(b=parseInt(String(a/1E9).substr(0,2)),a%=1E9,b=terbilang(b)+" Milyar "+terbilang(a)):
	1E12>a?(b=parseInt(String(a/1E9).substr(0,3)),a%=1E9,b=terbilang(b)+" Milyar "+terbilang(a)):1E13>a?(b=parseInt(String(a/1E10).substr(0,1)),a%=1E10,b=terbilang(b)+" Triliun "+terbilang(a)):1E14>a?(b=parseInt(String(a/1E12).substr(0,2)),a%=1E12,b=terbilang(b)+" Triliun "+terbilang(a)):1E15>a?(b=parseInt(String(a/1E12).substr(0,3)),a%=1E12,b=terbilang(b)+" Triliun "+terbilang(a)):1E16>a&&(b=parseInt(String(a/1E15).substr(0,1)),a%=1E15,b=terbilang(b)+" Kuadriliun "+terbilang(a));a=b.split(" ");c=[];for(b=0;b<a.length;b++)""!=a[b]&&c.push(a[b]);return c.join(" ")};
	return terbilang(value);
});
Vue.use(VueSweetalert2);
Vue.use(VuePanel);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})
// Vue.use(VueHtmlToPaper);
Vue.use(VueHtmlToPaper, vueHtmlToPaperOptions);

Vue.component('vue-universal-table' , vueUniversalTable);
Vue.component('flat-pickr', flatPickr)
Vue.component('MultiSelect' , MultiSelect);

Vue.mixin({
  methods : mixinMethods
})

Vue.config.productionTip = env.productionMode;

const store  =  new VueX.Store(storeOptions)
const _ = require('lodash');
router.beforeEach((to , from , next) => {
  // console.log(_.isEqual(to.params, from.params))
	if(to.name == from.name && _.isEqual(to.params, from.params)) {
		console.log('Removing Duplicate Path')
		return;
	}

	let requiresAuth = null
	if(typeof to.meta.requiresAuth != 'boolean') {
		let matched = to.matched
		requiresAuth = matched.find(x => x.meta.requiresAuth).meta.requiresAuth
	} else {
		requiresAuth = to.meta.requiresAuth
	}
	
	if(requiresAuth) {
		let user = store.getters.currentUser
		if(!user) {
			store.state.warningMessage = `Please Login Before Accessing Dashboard`
			store.state.routeBeforeAuth = to.name
			// console.log(to)
			store.state.realUrl = to.fullPath
			next({name : 'Login'})
			return
		}
	}

  next();
})

//inject Vue to Id = App
new Vue({
  el : '#app',
  store,
  router : router,
  render: h => h(App),
})

function logout(){
  
  //delete token 
}
